export default __webpack_public_path__ + "static/icon_collider_ventures_dark-84ac9962d30e0201a2485eff745d2b04.svg";